import React from 'react';
import { Heading, Slide, Section, preloader } from 'spectacle-ppa';
import { i18nData } from 'helpers/i18n';
import CompleteLevelButton from 'components/completeLevelButton';

import balloonSlide from '../../baseSlides/balloonSlide';

import ianSaraLeanSmile from '../../images/characters/ian_sara_lean_smile.png';
import ianSaraLeanQuestioning from '../../images/characters/ian_sara_lean_questioning.png';
import ianSaraSide from '../../images/characters/ian_sara_side.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFile_en from './finish.md';
import markdownFile_fr_CA from './finish.fr_CA.md';

const md = i18nData({
  en: new MarkdownScript(markdownFile_en),
  fr_CA: new MarkdownScript(markdownFile_fr_CA)
});

import imgLevel1Complete from './level-1_complete.svg';
import imgLevel2Complete from './level-2_complete.svg';
import imgLevel3Complete from './level-3_complete.svg';
import imgLevel4Complete from './level-4_complete.svg';

const levels = {
  '1': { img: imgLevel1Complete },
  '2': { img: imgLevel2Complete },
  '3': { img: imgLevel3Complete },
  '4': { img: imgLevel4Complete }
};

export function preloadFinish () {
  preloader([
    ianSaraLeanSmile,
    ianSaraSide,
    imgLevel1Complete,
    imgLevel2Complete,
    imgLevel3Complete,
    imgLevel4Complete
  ]);
}

function finishSection ({ level, regionData, i18n: _ }) {
  const md_i18n = _(md);
  return (
    <Section id="finish">

      {/* Scoreboard Recap */}
      { (level !==4) &&
        balloonSlide({
          id: 'scoreboard-recap',
          characterSide: 'left',
          characterImage: ianSaraSide,
          html: md_i18n.getSubSectionAsHtml('Scoreboard Recap', 'Content', false, regionData),
          notes: md_i18n.getSubSectionAsHtml('Scoreboard Recap', 'Notes', false, regionData)
        })
      }

      {/* Earn More Points */}
      { (level !==4) &&
        balloonSlide({
          id: 'earn-more-points',
          characterSide: 'right',
          characterImage: ianSaraLeanQuestioning,
          html: md_i18n.getSubSectionAsHtml('Earn More Points', 'Content', false, regionData),
          notes: md_i18n.getSubSectionAsHtml('Earn More Points', 'Notes', false, regionData)
        })
      }

      {/* Farewell */}
      { (level !==4) &&
        balloonSlide({
          id: 'farewell',
          characterSide: 'left',
          characterImage: ianSaraLeanSmile,
          html: md_i18n.getSubSectionAsHtml('Farewell', 'Content', false, regionData),
          notes: md_i18n.getSubSectionAsHtml('Farewell', 'Notes', false, regionData)
        })
      }

      {/* Farewell */}
      { (level ===4) &&
        balloonSlide({
          id: 'farewell',
          characterSide: 'left',
          characterImage: ianSaraLeanSmile,
          html: md_i18n.getSubSectionAsHtml('Farewell Last', 'Content', false, regionData),
          notes: md_i18n.getSubSectionAsHtml('Farewell Last', 'Notes', false, regionData)
        })
      }

      {/* Level complete */}
      <Slide
      id="level-completed"
      notes={'<h2>' + _`Level ${level} Finished` + '</h2>'}
      bgColor="transparent"
      finish>
        <div className="level-complete">
          <div className="level-complete-content">
              <figure className="level-complete-graphic"><img src={levels[level].img}/></figure>
              <Heading size={2}>
                {_("You've finished")}
              </Heading>
              <Heading size={2}>
                {_`level ${level} of 4`}
              </Heading>
              <CompleteLevelButton/>
          </div>
        </div>
      </Slide>

    </Section>
  );
}

export default finishSection;



// WEBPACK FOOTER //
// ./programs/h2whoa/sections/90_finish/finishSection.jsx